/* eslint-disable sonarjs/no-duplicate-string */
import {
  CUSTOMIZATION_LABEL_TO_SECTION_METADATA_KEY,
  DEFAULT_LABELS_PER_SECTION_KEY,
  SECTIONS_METADATA,
} from "../../../reports";
import { dataTableCopy } from "../../../resources/dataTableCopy";

const footnotes = {
  "1-Sheeter Summary": null,
  "Attribution of Tracking Error": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: `${dataTableCopy.unlessOtherwiseStated}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.targetPortfolios}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[2] ${dataTableCopy.styleRiskAndSector}`,
      },
    ],
  },
  "Firm Overview": null,
  "Portfolio Characteristics": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: `${dataTableCopy.unlessOtherwiseStated}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.targetPortfolios}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[2] ${dataTableCopy.seeBenchmark}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[3] ${dataTableCopy.calculationExcludes}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[4] ${dataTableCopy.statsExcludeExposure}`,
      },
    ],
  },
  "Sectors GICS": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: `${dataTableCopy.unlessOtherwiseStated}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.sectorExposure}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[2] ${dataTableCopy.targetPortfolios}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[3] ${dataTableCopy.seeBenchmark}`,
      },
    ],
  },
  "Sectors Risk Exposure": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: `${dataTableCopy.unlessOtherwiseStated}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.equitySecuritiesSector}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[2] ${dataTableCopy.targetPortfolios}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[3] ${dataTableCopy.seeBenchmark}`,
      },
    ],
  },
  "Style Risk Exposure": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: `${dataTableCopy.unlessOtherwiseStated}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.topSevenStyleFactor}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[2] ${dataTableCopy.targetPortfolios}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[3] ${dataTableCopy.seeBenchmark}`,
      },
    ],
  },
  "Target Portfolio": {
    type: "div",
    props: { className: "footnotes" },
    children: [
      {
        type: "p",
        props: { className: "footnotes__subheader" },
        children: `${dataTableCopy.unlessOtherwiseStated}`,
      },
      {
        type: "p",
        props: { className: "footnotes__item" },
        children: `[1] ${dataTableCopy.targetPortfolios}`,
      },
    ],
  },
  Definitions: null,
  Disclosures: null,
};

const labels = {
  "1-Sheeter Summary": {
    Proposal: "Remi Cash Proposal",
  },
  "Attribution of Tracking Error": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Attribution of Tracking Error"],
    "Target Portfolio": ["Target", "Portfolio[1]"],
    "Sector Risk": "Sector Risk[2]",
    "Style Risk": "Style Risk[2]",
    "Balance Tax Liability & Tracking Error": [
      "Balance Tax Liability &",
      "Tracking Error",
    ],
  },
  "Portfolio Characteristics": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Portfolio Characteristics"],
    "Target Portfolio": ["Target", "Portfolio[1]"],
    Benchmark: "Benchmark[2]",
    "Number of Securities": "Number of Securities[3]",
    "Average Weighted Market Cap (Billions $)":
      "Average Weighted Market Cap (Billions $)[4]",
    "Large Cap (%)": "Large Cap (%)[4]",
    "Mid Cap (%)": "Mid Cap (%)[4]",
    "Moderately Cyclical Sectors (%)": "Moderately Cyclical Sectors (%)[4]",
    "Highly Cyclical Sectors (%)": "Highly Cyclical Sectors (%)[4]",
    "Small Cap (%)": "Small Cap (%)[4]",
    "Defensive Sectors (%)": "Defensive Sectors (%)[4]",
  },
  "Sectors GICS": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Sectors GICS"],
    "Sectors (GICS®)": "Sectors (GICS®)[1]",
    "Target Portfolio": ["Target", "Portfolio[2]"],
    Benchmark: "Benchmark[3]",
  },
  "Sectors Risk Exposure": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Sectors Risk Exposure"],
    "Sectors (Risk Exposure)": "Sectors (Risk Exposure)[1]",
    "Target Portfolio": ["Target", "Portfolio[2]"],
    Benchmark: "Benchmark[3]",
  },
  "Style Risk Exposure": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Style Risk Exposure"],
    "Style Risk Exposure": "Style Risk Exposure[1]",
    "Target Portfolio": ["Target", "Portfolio[2]"],
    Benchmark: "Benchmark[3]",
  },
  "Target Portfolio": {
    ...DEFAULT_LABELS_PER_SECTION_KEY["Target Portfolio"],
    "Target Portfolio": ["Target", "Portfolio[1]"],
  },
};

export const getCashEquityMetadata = () => {
  return Object.entries(SECTIONS_METADATA).reduce(
    (acc, [sectionMetadataKey, staticSectionMetadata]) => {
      const labelsKey = Object.keys(
        CUSTOMIZATION_LABEL_TO_SECTION_METADATA_KEY
      ).find(
        (key) =>
          CUSTOMIZATION_LABEL_TO_SECTION_METADATA_KEY[key] ===
          sectionMetadataKey
      );

      const titleOverride = labels[labelsKey]?.[staticSectionMetadata.title];

      const updatedSectionMetadata = {
        ...staticSectionMetadata,
        reportType: "cash",
        assetType: "equity",

        footnotes:
          footnotes[staticSectionMetadata.customizations.label] ||
          staticSectionMetadata.footnotes,
        labels: labels[staticSectionMetadata.customizations.label],
        title:
          (Array.isArray(titleOverride)
            ? titleOverride.join(" ")
            : titleOverride) || staticSectionMetadata.title,
        table1: staticSectionMetadata.table1 && {
          ...staticSectionMetadata.table1,
          tableRowHeaderKey:
            labels[labelsKey]?.[
              staticSectionMetadata?.table1?.tableRowHeaderKey
            ] || staticSectionMetadata.table1?.tableRowHeaderKey,
        },
      };
      return {
        ...acc,
        [sectionMetadataKey]: updatedSectionMetadata,
      };
    },
    {}
  );
};
